import React, { useCallback, useContext } from 'react';

import { BequestsContext, BequestsProvider } from '../../context/bequests.provider';

import { AssetHeader, Beneficiaries } from '.';

interface Asset {
  id: string;
  name: string;
  type: string;
  description: string;
  beneficiaries: Array<Beneficiary>;
}

interface Beneficiary {
  firstName: string;
  lastName: string;
  contactEmail: string;
  contactPhone: string;
}

interface AssetListProps {
  assets: Asset[];
  handleRemove: (index: string) => void;
  handleEdit: (index: string) => void;
}

export function AssetList({ assets, handleRemove, handleEdit }: AssetListProps) {
  return (
    <div className="asset-list">
      {assets.map((asset, index) => (
        <BequestsProvider key={asset?.id} assetId={asset?.id}>
          <AssetDetail 
            key={index}
            asset={asset} 
            handleRemove={handleRemove}
            handleEdit={handleEdit}
          />
        </BequestsProvider>
      ))}
    </div>
  );
}

interface AssetDetailProps {
  asset: Asset;
  handleRemove: (index: string) => void;
  handleEdit: (index: string) => void;
}

function AssetDetail({ asset, handleRemove, handleEdit }: AssetDetailProps) {
  console.log('AssetDetail', asset);
  const { bequests } = useContext(BequestsContext);
  
  const handleRemoveAsset = useCallback(() => {
    handleRemove(asset.id);
  }, [ asset.id, handleRemove ]);

  const handleEditAsset = useCallback(() => {
    handleEdit(asset.id);
  }, [ asset.id, handleEdit ]);

  return (
    <div className="asset-detail">
      <AssetHeader asset={asset} handleRemove={handleRemoveAsset} handleEdit={handleEditAsset} />
      <Beneficiaries beneficiaries={bequests} />
    </div>
  );
}

export { AssetDetail };
